module.exports = __webpack_public_path__ + "images/skb-bank2-ce56f5d4.png";